import { LotDecorated } from '@common/models/lots/types';

const constructDateTimeString = (timestamp: string) => {
  return `${new Date(timestamp).toLocaleDateString()} ${new Date(timestamp).toLocaleTimeString()}`;
};

const constructStockingPeriod = (lot: LotDecorated) => {
  if (!lot.firstStockingDate || !lot.latestStockingDate) {
    return 'N/A';
  }

  const firstStockingDateReadable = constructDateTimeString(lot.firstStockingDate);
  const latestStockingDateReadable = constructDateTimeString(lot.latestStockingDate);

  return `${firstStockingDateReadable} - ${latestStockingDateReadable}`;
};

export default constructStockingPeriod;
